module.exports = __webpack_public_path__ + "img/qgd.0ad5653b.png";